import React, { useContext, useMemo } from "react";
import { Route, Redirect } from "react-router-dom";
import AppContext from "../context/Context";
import { CloseButton, ToastContainer } from "react-bootstrap";
import { Fade } from "reactstrap";
import { toast } from "react-toastify";
import UnauthorizedAccessLayout from "../layouts/UnauthorizedAccessLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import { setItemToStore } from "../helpers/utils";

function UserPrivateRoute({ component: Component, path, ...rest }) {
  let pathSplit = path.split("/");
  const { loginUserDetails } = useContext(AppContext);

  let rolesPerComponent = [
    {
      name: "partner-details",
      handlers: [
        "liUpdateDetailsButton",
        "liDeletePartnerButton",
        "liAddApplicationButton",
        "liUpdateApplicationButton",
        "liDeleteApplicationButton",
        "liApiAccessButton",
        "liApiAccessGridButton",
        "liCheckDataAvailableGridButton",
        "liDeletePartnerCustomerButton",
        "liAddTeamMemberButton",
        "liLogInAccessGridButtonAllowRevoke",
        "liAccessTypeGridButtonFullReadOnly",
        "liApplicationIDLabel",
        "liApplicationKeyTable",
        "liTeamMemberGenerateLink"
      ],
    },
    {
      name: "api-explorer",
      handlers: ["liApiTestingToolPartnerDropdown"],
    },
    {
      name: "billing",
      handlers: ["liPartnerDropDownControl"],
    },
  ];

  const allowedActions = (componentName) => {
    let selectedRole = rolesPerComponent.find((roles) => {
      return roles.name === componentName;
    });
    if (selectedRole) {
      selectedRole.handlers = selectedRole?.handlers.filter((handler) => {
        return !loginUserDetails.user_not_acccess_list.includes(handler);
        // return !roles.includes(handler);
      });
    }
    return selectedRole;
    // return loginUserDetails.user_not_acccess_list.find((accessAction) => accessAction === componentName);

    // return loginUserDetails.allowedActionsNamePerComponent?.find((page) => componentName === page.modulePage);
  };
  
  useMemo(()=>{
   if (JSON.parse(localStorage.getItem("isLoggedIn"))) {
     
      setItemToStore("lastPath",window.location.pathname.replace("/v4/portal/",""))   
    }
  },[window.location.href])

  return (
    Object.keys(loginUserDetails).length > 0 && (
      <Route
        {...rest}
        render={(props) =>
          localStorage.getItem("isLoggedIn") === "true" &&
          loginUserDetails &&
          Object.keys(loginUserDetails).length > 0 &&
          loginUserDetails.is_partner === "1" &&
          loginUserDetails.is_verified?.toLowerCase() === "yes" &&
          ((loginUserDetails.nda_status?.toLowerCase() === "signed" ||
            loginUserDetails.nda_status?.toLowerCase() === "") || loginUserDetails.user_type.toLowerCase() !="super admin" ) ? (
            <Component {...props} actions={allowedActions(pathSplit[pathSplit.length - 1])} />
          ) : (
            <>
            <Route component={ErrorLayout} />
            <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
            </>
          )
        }
      />
    )
  );
}

export default UserPrivateRoute;
